import { EFeatureFlags } from 'astra-core/containers/ConfigProvider'
import { Tournament } from 'betweb-openapi-axios'

import { selectLineTournamentsEventsCounters } from 'pages/page-line-tournament/LineTournamentsContainer/selectors'
import { useAppFeatureFlag } from 'shared/config/feature-flags/useAppFeatureFlag'
import { useAppSelector } from 'store'

export const useLineTournamentEventsCount = ({
  id,
  lineEventCount
}: Tournament): number | null | undefined => {
  const isNewCountersEndpoint = useAppFeatureFlag(
    EFeatureFlags.NEW_COUNTERS_ENDPOINT
  )

  const count = useAppSelector((state) =>
    selectLineTournamentsEventsCounters(state)
  )

  return isNewCountersEndpoint ? count[id]?.count : lineEventCount
}
